const XHR = window.XDomainRequest || window.XMLHttpRequest;
const JSON = window.JSON || {};
if (!JSON.parse) {
  JSON.parse = (str) => {
    if (str === '') {
      str = '""';
    }
    const jsp = {};
    eval(`jsp=${str};`);
    return jsp;
  };
}

export default class AdFoxLPD {
  constructor() {
    this.cookieDomain = 'v.adfox.ru';
  }

  prepareLink = (url, callback) => {
    this.getID((err, id) => {
      if (err) {
        callback(err, url.replace('getCode', 'getCodeTest'));
      } else {
        callback(false, `${url}&lpdid=${id}`);
      }
    });
  };

  getID = (callback) => {
    let cookie;
    let ls;
    try {
      const matchCookie = document.cookie.match(/(?:^|; )lpdid=([^;]*)/);
      cookie = matchCookie ? decodeURIComponent(matchCookie[1]) : null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(err.message);
    }
    try {
      ls = window.localStorage.getItem('lpdid')
        ? window.localStorage.getItem('lpdid')
        : null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(err.message);
    }
    if (ls || cookie) {
      callback(null, ls || cookie);
    } else {
      const xhr = new XHR();
      xhr.open(
        'GET',
        `//${this.cookieDomain}/getid?pr=${Math.round(Math.random() * 10000000)}&t=json`,
        true
      );
      xhr.onload = () => {
        try {
          const lpdid = JSON.parse(xhr.responseText).lpd_id;
          if (lpdid) {
            callback(false, lpdid);

            const date = new Date();
            date.setDate(date.getDate() + 365);
            document.cookie = `lpdid=${lpdid};expires=${date.toUTCString()};path=/`;
            window.localStorage.setItem('lpdid', lpdid);
          } else {
            callback(true, null);
          }
        } catch (err) {
          callback(err, null);
        }
      };
      xhr.onerror = () => {
        callback(true, null);
      };
      xhr.withCredentials = true;
      xhr.send(null);
    }
  };
}
